import React, { Component } from 'react';
import { Modal, notification } from 'antd';

import PasswordTable from './PasswordTable';
import { getAll } from '../../api/password';
import { MESSAGES } from './strings';

import { deletePassword, updatePassword, updatePasswordStatus, bulkDeletePasswords, exDeletePasswords } from '../../api/password';

const { confirm } = Modal;

class Password extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: false,
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { isReload } = nextProps;
    if (isReload) {
      this.loadPasswords();
      this.props.callNotReload();
    }
  }

  componentDidMount() {
    this.loadPasswords();
  }

  loadPasswords = () => {
    this.setState({ isLoading: true });
    getAll().then(({ data }) => {
      const { result } = data;
      this.setState({ data: result.reverse() })
    }).finally(() => this.setState({ isLoading: false }));
  }

  handleDeletePassword(id) {
    confirm({
      title: MESSAGES.CONFIRM_DELETE_PASSWORD,
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      width: 435,
      onOk: () => {
        deletePassword(id).then(() => {
          notification['success']({
            message: 'PPWP Lite',
            description: 'Great! You’ve deleted the password successfully.',
          });
          let { data } = this.state;
          const foundIndex = data.findIndex(value => value.id === id);
          if (foundIndex === -1) {
            return;
          }
          data.splice(foundIndex, 1);
          this.setState({ data });
        })
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  handleSetPasswordStatus(id, is_activated) {
    is_activated = is_activated === "1" ? true : false;
    updatePasswordStatus(id, !is_activated)
      .then(() => {
        const { data } = this.state;
        const foundIndex = data.findIndex(value => {
          return value.id === id;
        })
        if (foundIndex === -1) {
          notification['error']({
            message: 'PPWP Lite',
            description: 'Failed to update the password.',
          });
        }
        let passwords = data;
        passwords[foundIndex].is_activated = is_activated ? '0' : '1';
        this.setState({ data: passwords });
        notification['success']({
          message: 'PPWP Lite',
          description: 'Great! You’ve updated the password successfully.',
        });
      })
      .catch(() => notification['error']({
        message: 'PPWP Lite',
        description: MESSAGES.DEFAULT_ERROR_MESSAGE,
      }));
  }

  handleChangeExpiredDate = (expired_date, id) => {
    return updatePassword(id, { expired_date }).then(() => {
      const { data } = this.state;
      const foundIndex = data.findIndex(value => value.id === id)
      let passwords = data;
      passwords[foundIndex].expired_date = expired_date ? expired_date.toString() : null;
      this.setState({ data: passwords });
      return Promise.resolve(true);
    })
  }

  handleChangeLabel = (label, id) => {
    return updatePassword(id, { label }).then(() => {
      const { data } = this.state;
      const foundIndex = data.findIndex(value => value.id === id)
      let passwords = data;
      passwords[foundIndex].label = label;
      this.setState({ data: passwords });
      return Promise.resolve(true);
    })
  }


  handleChangeUsageLimit(val, id) {
    if (val <= 0) {
      val = null;
    }
    val = Math.round(parseFloat(val));
    return updatePassword(id, { usage_limit: val }).then(() => {
      const { data } = this.state;
      const foundIndex = data.findIndex(value => value.id === id);
      let passwords = data;
      passwords[foundIndex].usage_limit = val.toString();
      this.setState({ data: passwords });
      return Promise.resolve(true);
    });
  }

  handleDeleteSelectedPasswords = (ids, cb, setStatus) => {
    confirm({
      title: MESSAGES.CONFIRM_DELETE_PASSWORDS,
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      width: 435,
      onOk: () => {
        setStatus(true);
        bulkDeletePasswords(ids).then((response) => {
          const { data: { message } } = response;
          notification['success']({
            message: 'PPWP Lite',
            description: message,
          });
          let { data } = this.state;
          data = data.filter(value => {
            return ids.indexOf(value.id) === -1;
          });
          this.setState({ data });
        }).catch(error => {
          notification['error']({
            message: 'PPWP Lite',
            description: error.message,
          });
        })
        .finally(() => {
          cb();
          setStatus(false);
        });
      },
    });
}

handleDeleteExPasswords = (ids, cb, setStatus) => {
  confirm({
    title: MESSAGES.CONFIRM_DELETE_ALL_EXPIRED_PASSWORDS,
    okText: 'Yes',
    okType: 'danger',
    cancelText: 'No',
    width: 435,
    onOk: () => {
      setStatus(true);
      exDeletePasswords(ids).then((response) => {
        const { data: { message } } = response;
        notification['success']({
          message: 'PPWP Lite',
          description: message,
        });
        let { data } = this.state;
        data = data.filter(value => {
          return ids.indexOf(value.id) === -1;
        });
        this.setState({ data });
        setTimeout(function(){
          window.location.reload(1);
       }, 3000);
      }).catch(error => {
        notification['error']({
          message: 'PPWP Lite',
          description: MESSAGES.ERROR_DELETE_ALL_EXPIRED_PASSWORDS,
        });
      })
      .finally(() => {
        cb();
        setStatus(false);
      });
    },
  });
}

  render() {
    const { data, isLoading } = this.state;
    const { levels } = this.props;
    return (
      <div className="ppwp-group">
        <PasswordTable
          data={data}
          loading={isLoading}
          levels={levels}
          handleDeletePassword={(id) => this.handleDeletePassword.bind(this, id)}
          handleSetPasswordStatus={(id, is_activated) => this.handleSetPasswordStatus.bind(this, id, is_activated)}
          handleChangeUsageLimit={(val, id) => this.handleChangeUsageLimit(val, id)}
          handleChangeExpiredDate={(val, id) => this.handleChangeExpiredDate(val, id)}
          handleChangeLabel={(val, id) => this.handleChangeLabel(val, id)}
          handleDeleteSelectedPasswords = {(ids, cb, setStatus) => this.handleDeleteSelectedPasswords(ids, cb, setStatus)}
          handleDeleteExPasswords = {(ids, cb, setStatus) => this.handleDeleteExPasswords(ids, cb, setStatus)}
        />
      </div>
    );
  }
}

export default Password;



// WEBPACK FOOTER //
// ./components/PasswordTable/index.js